module.exports = __webpack_public_path__ + "static/media/MCT-Web-Slider_3_1020px.bfd7416d.jpg";